import React from 'react';
import { Item, SwitchButtonContainer } from './styles';

type SwitchButtonProps = {
  items: any[];
  disabled?: boolean;
  value?: string;
  onChange?: (item: any) => void;
  itemLabelIdentifier?: string;
  itemValueIdentifier?: string;
};

const SwitchButton = (props: SwitchButtonProps) => {
  const {
    items,
    onChange = () => {},
    disabled,
    value = 'none',
    itemLabelIdentifier = 'label',
    itemValueIdentifier = 'value',
  } = props;
  return (
    <SwitchButtonContainer>
      {items.map((item) => (
        <Item
          key={item[itemValueIdentifier]}
          type="button"
          disabled={disabled}
          onClick={() => {
            if (disabled) return;
            onChange(item);
          }}
          className={value === item[itemValueIdentifier] ? 'selected' : ''}
        >
          {item[itemLabelIdentifier]}
        </Item>
      ))}
    </SwitchButtonContainer>
  );
};

export default SwitchButton;
